<div class="general-body">
    <div class="body-container">

        <form [formGroup]="form">
            <div class="messages-section margin-0px d-flex flex-column flex-lg-row">
                <div class="pick-convirsation col-xl-4 col-12 ">
                    <div class="message-table">

                        <div class="convirsations p-3">
                            <!-- Search Input -->
                            <!-- Search Input using formControlName -->

                            <div class="search-record">
                                <div class="form">
                                    <i class="fa fa-search-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
                                                stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path d="M18.9304 20.6898C19.4604 22.2898 20.6704 22.4498 21.6004 21.0498C22.4504 19.7698 21.8904 18.7198 20.3504 18.7198C19.2104 18.7098 18.5704 19.5998 18.9304 20.6898Z"
                                                stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </svg>
                                    </i>
                                    <input type="text" class="form-control form-input" placeholder="Search" formControlName="search">
                                </div>
                            </div>


                            <hr>

                            <div class="message-navigation-pane" style="overflow-y: auto; max-height: 400px;">


                                <div *ngFor="let message of filteredMessages; let i = index" class="message-general py-2 d-flex align-items-center" [ngClass]="{'selected': isMessageSelected(message)}" (click)="selectMessage(message)">

                                    <!-- Message Icon -->
                                    <div class="message-icon col-3 col-sm-3 col-md-3 d-flex justify-content-center">
                                        <svg width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <rect x="0.5" width="46" height="46" rx="23" fill="#FFF4FF" />
                                 <path d="M28.5 20C28.5 23.87 25.14 27 21 27L20.07 28.12L19.52 28.78C19.05 29.34 18.15 29.22 17.84 28.55L16.5 25.6C14.68 24.32 13.5 22.29 13.5 20C13.5 16.13 16.86 13 21 13C24.02 13 26.63 14.67 27.8 17.07C28.25 17.96 28.5 18.95 28.5 20Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                 <path d="M33.5003 23.8598C33.5003 26.1498 32.3203 28.1798 30.5003 29.4598L29.1603 32.4098C28.8503 33.0798 27.9503 33.2098 27.4803 32.6398L26.0003 30.8598C23.5803 30.8598 21.4203 29.7898 20.0703 28.1198L21.0003 26.9998C25.1403 26.9998 28.5003 23.8698 28.5003 19.9998C28.5003 18.9498 28.2503 17.9598 27.8003 17.0698C31.0703 17.8198 33.5003 20.5798 33.5003 23.8598Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                 <path d="M18.5 20H23.5" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                               </svg>
                                    </div>

                                    <!-- Message Text -->
                                    <div class="message-text col-9 col-sm-9 col-md-9">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <h6 class="mb-0">{{ getModuleDisplayName(message) }}</h6>
                                            </div>
                                        </div>
                                        <!-- Grouped message content -->
                                        <span class="light-text-m email-details1" [innerText]="message.messageContent"></span>

                                        <div class="day-time d-flex align-items-center mt-2">
                                            <svg class="time-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                   <path d="M14.6663 7.99967C14.6663 11.6797 11.6797 14.6663 7.99967 14.6663C4.31967 14.6663 1.33301 11.6797 1.33301 7.99967C1.33301 4.31967 4.31967 1.33301 7.99967 1.33301C11.6797 1.33301 14.6663 4.31967 14.6663 7.99967Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                   <path d="M10.4729 10.1202L8.40626 8.88684C8.04626 8.6735 7.75293 8.16017 7.75293 7.74017V5.00684" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                 </svg>
                                            <p class="email-details1 mb-0 ml-2" *ngIf="message.CreatedAt">{{ formatDate(message.CreatedAt) }}</p>
                                        </div>
                                    </div>

                                </div>



                            </div>




                            <hr>






                        </div>
                    </div>

                </div>

                <div class="d-flex justify-content-center align-items-center col-xl-8 col-12  ms-0 mt-xl-0 mt-3 ">
                    <div class="chat-container">


                        <div class="chat-header d-flex justify-content-between align-items-center" *ngIf="selectedMessage">

                            <div class="d-flex">
                                <div class="me-2">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="46" height="46" rx="8" fill="black" fill-opacity="0.06"/>
                                            <path d="M28 20C28 23.87 24.64 27 20.5 27L19.57 28.12L19.02 28.78C18.55 29.34 17.65 29.22 17.34 28.55L16 25.6C14.18 24.32 13 22.29 13 20C13 16.13 16.36 13 20.5 13C23.52 13 26.13 14.67 27.3 17.07C27.75 17.96 28 18.95 28 20Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M32.9998 23.8603C32.9998 26.1503 31.8198 28.1803 29.9998 29.4603L28.6598 32.4103C28.3498 33.0803 27.4498 33.2103 26.9798 32.6403L25.4998 30.8603C23.0798 30.8603 20.9198 29.7903 19.5698 28.1203L20.4998 27.0003C24.6398 27.0003 27.9998 23.8703 27.9998 20.0003C27.9998 18.9503 27.7498 17.9603 27.2998 17.0703C30.5698 17.8203 32.9998 20.5803 32.9998 23.8603Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M18 20H23" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                </div>
                                <div>
                                    <span class="fw-bold">{{ getModuleDisplayName(selectedMessage,true)  }} </span>
                                    <br>

                                    <span class="text-muted">{{ getModuleDisplayName(selectedMessage,false) }}</span>
                                </div>
                            </div>




                        </div>

                        <!-- <div *ngIf="relatedMessages.length > 0; else noMessages">
                            <div *ngFor="let message of relatedMessages">
                              <pre>{{ message | json }}</pre> 
                            </div>
                        </div> -->
                        <!-- <ng-template #noMessages>
                            <p>No messages to display</p>
                          </ng-template> -->

                        <!-- Chat Body (Display messages related to the selected reference number or general messages) -->
                        <div #chatBody class="chat-body d-flex flex-column align-items-end" *ngIf="relatedMessages.length > 0">
                            <div class="col-12">
                                <div class="history d-flex justify-content-center">
                                    <div class="px-2">
                                        {{ relatedMessages[relatedMessages.length - 1].CreatedAt ? formatDate(relatedMessages[relatedMessages.length - 1].CreatedAt!) : '' }}
                                    </div>
                                </div>

                                <div *ngFor="let message of relatedMessages" [ngClass]="{'received': message.direction?.toLowerCase() === 'Inbound'.toLowerCase(), 'sent': message.direction?.toLowerCase() === 'Outbound'.toLowerCase()}" class="chat-message mt-5">
                                    <div *ngIf="message.direction?.toLowerCase() === 'Inbound'.toLowerCase()" class="message-text-rec">{{ message.messageContent }}</div>
                                    <div *ngIf="message.direction?.toLowerCase() === 'Outbound'.toLowerCase()" class="message-text-sen">{{ message.messageContent }}</div>
                                    <div class="text-muted small mt-1">
                                        {{ message.CreatedAt ? formatDate(message.CreatedAt!) : 'Unknown time' }}
                                    </div>
                                </div>
                            </div>
                        </div>





                        <!-- Chat Footer (Typing input for sending a new message) -->
                        <div class="chat-footer" *ngIf="selectedMessage">
                            <textarea id="chatInput" class="form-control chat-input" placeholder="Type your message here..." formControlName="message" (keydown.enter)="sendMessage()"></textarea> <button id="sendButton" (click)="sendMessage()">
      <svg width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="39" height="38" rx="19" fill="#532E60" />
        <path d="M15.4747 14.2668L22.9035 11.9085C26.2372 10.8501 28.0485 12.5835 26.946 15.7585L24.4697 22.8335C22.8072 27.5918 20.0772 27.5918 18.4147 22.8335L17.6797 20.7335L15.4747 20.0335C10.4785 18.4501 10.4785 15.8585 15.4747 14.2668Z" stroke="white" stroke-width="1.05882" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M17.8462 20.3745L20.9787 17.3828" stroke="white" stroke-width="1.05882" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
                        </div>

                    </div>
                </div>
            </div>
        </form>

    </div>
</div>